export enum EmployeeStatus {
  active = 'active',
  onLeave = 'on_leave',
  terminated = 'terminated',
  pending = 'pending',
}

export enum Department {
  sales = 'sales',
  marketing = 'marketing',
  engineering = 'engineering',
  operations = 'operations',
  support = 'support',
  hr = 'hr',
  finance = 'finance',
  legal = 'legal',
  compliance = 'compliance',
  executive = 'executive',
}

export enum OnboardingStatus {
  notStarted = 'not_started',
  inProgress = 'in_progress',
  completed = 'completed',
  blocked = 'blocked',
}

export enum TimeOffType {
  vacation = 'vacation',
  sick = 'sick',
  personal = 'personal',
  fmla = 'fmla',
  unpaid = 'unpaid',
  other = 'other',
}

export enum TimeOffStatus {
  pending = 'pending',
  approved = 'approved',
  rejected = 'rejected',
  cancelled = 'cancelled',
}

export interface Employee {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  phoneNumber?: string;
  department: Department;
  role: string;
  managerId?: string;
  managerName?: string;
  status: EmployeeStatus;
  startDate: Date;
  endDate?: Date;
  employeeNumber?: string;
  photoUrl?: string;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  emergencyContactName?: string;
  emergencyContactPhone?: string;
  emergencyContactRelation?: string;
  salary?: number;
  hourlyRate?: number;
  employmentType: 'full_time' | 'part_time' | 'contractor' | 'intern';
  createdAt: Date;
  lastUpdated: Date;
  metadata?: Record<string, unknown>;
}

export interface OnboardingTask {
  id: string;
  employeeId: string;
  title: string;
  description?: string;
  assignedTo?: string;
  dueDate?: Date;
  completed: boolean;
  completedAt?: Date;
  completedBy?: string;
  category: 'documentation' | 'training' | 'equipment' | 'access' | 'other';
  createdAt: Date;
}

export interface Onboarding {
  id: string;
  employeeId: string;
  employeeName: string;
  status: OnboardingStatus;
  startDate: Date;
  completedDate?: Date;
  tasks: OnboardingTask[];
  notes?: string;
  createdAt: Date;
  lastUpdated: Date;
}

export interface TimeOffRequest {
  id: string;
  employeeId: string;
  employeeName: string;
  type: TimeOffType;
  startDate: Date;
  endDate: Date;
  days: number;
  status: TimeOffStatus;
  reason?: string;
  requestedAt: Date;
  approvedBy?: string;
  approvedAt?: Date;
  rejectedBy?: string;
  rejectedAt?: Date;
  rejectionReason?: string;
  createdAt: Date;
  lastUpdated: Date;
}

export interface EmployeeDocument {
  id: string;
  employeeId: string;
  name: string;
  type: 'contract' | 'nda' | 'i9' | 'w4' | 'direct_deposit' | 'license' | 'certification' | 'other';
  fileUrl: string;
  expiresAt?: Date;
  uploadedAt: Date;
  uploadedBy: string;
  metadata?: Record<string, unknown>;
}

export interface PerformanceReview {
  id: string;
  employeeId: string;
  employeeName: string;
  reviewPeriod: string; // e.g., "Q1 2024"
  reviewDate: Date;
  reviewedBy: string;
  reviewedByName: string;
  rating?: number; // 1-5
  strengths?: string[];
  areasForImprovement?: string[];
  goals?: string[];
  notes?: string;
  createdAt: Date;
  lastUpdated: Date;
}

